document.addEventListener('DOMContentLoaded', function () {

  /* ===== Selector de variantes + precio dinámico ===== */
  var elVariantes = document.getElementById('datos-variantes');
  if (elVariantes) {
    var variantes = JSON.parse(elVariantes.textContent || '[]');
    var seleccion = variantes.length ? variantes[0].options.slice() : [];
    // Texto original del boton, para restaurarlo sin machacarlo con un literal.
    var textoBotonOriginal = (document.getElementById('boton-comprar-texto') || {}).textContent || 'Añadir al carrito';

    function formatear(cents) {
      try {
        return new Intl.NumberFormat('es-ES', { style: 'currency', currency: window.__moneda || 'EUR' }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' €';
      }
    }

    function encontrarVariante() {
      return variantes.find(function (v) {
        return v.options.every(function (val, i) { return val === seleccion[i]; });
      });
    }

    function refrescarPrecio() {
      var v = encontrarVariante();
      var input = document.getElementById('input-variant-id');
      var actual = document.getElementById('precio-actual');
      var antes = document.getElementById('precio-antes');
      var ahorro = document.getElementById('precio-ahorro');
      var boton = document.getElementById('boton-comprar');
      var textoBoton = document.getElementById('boton-comprar-texto');
      if (!v) {
        if (boton) boton.setAttribute('disabled', 'disabled');
        if (textoBoton) textoBoton.textContent = 'No disponible';
        return;
      }
      if (input) input.value = v.id;
      if (actual) actual.textContent = formatear(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (antes) { antes.style.display = ''; antes.textContent = formatear(v.compare_at_price); }
        if (ahorro) { ahorro.style.display = ''; ahorro.textContent = 'Ahorras ' + formatear(v.compare_at_price - v.price); }
      } else {
        if (antes) antes.style.display = 'none';
        if (ahorro) ahorro.style.display = 'none';
      }
      if (boton) boton.removeAttribute('disabled');
      if (textoBoton) textoBoton.textContent = textoBotonOriginal;
    }

    document.querySelectorAll('.opcion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.getAttribute('data-opcion'), 10);
        var val = btn.getAttribute('data-valor');
        seleccion[i] = val;
        document.querySelectorAll('.opcion-bloque[data-index="' + i + '"] .opcion-btn').forEach(function (b) {
          b.classList.remove('activa');
        });
        btn.classList.add('activa');
        refrescarPrecio();
      });
    });
  }

  /* ===== Galería: miniaturas ===== */
  document.querySelectorAll('.mini-btn').forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-src');
      var principal = document.getElementById('img-principal');
      if (principal && src) principal.src = src;
      document.querySelectorAll('.mini-btn').forEach(function (m) { m.classList.remove('activa'); });
      mini.classList.add('activa');
    });
  });

  /* ===== Cantidad +/- ===== */
  var inputCantidad = document.getElementById('input-cantidad');
  var btnMas = document.getElementById('btn-mas');
  var btnMenos = document.getElementById('btn-menos');
  if (btnMas) btnMas.addEventListener('click', function () {
    inputCantidad.value = Math.max(1, parseInt(inputCantidad.value || 1, 10) + 1);
  });
  if (btnMenos) btnMenos.addEventListener('click', function () {
    inputCantidad.value = Math.max(1, parseInt(inputCantidad.value || 1, 10) - 1);
  });

  /* ===== FAQ acordeón ===== */
  document.querySelectorAll('.faq-pregunta').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var abierta = item.classList.contains('abierta');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('abierta'); });
      if (!abierta) item.classList.add('abierta');
    });
  });

  /* ===== Barra flotante móvil (aparece al hacer scroll) ===== */
  var barra = document.getElementById('barra-flotante-movil');
  var cajaPrecio = document.querySelector('.hero-precio-caja');
  if (barra && cajaPrecio && window.innerWidth <= 900) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          barra.classList.remove('visible');
        } else if (entry.boundingClientRect.top < 0) {
          barra.classList.add('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(cajaPrecio);
  }

  /* ===== Envío del formulario: feedback visual ===== */
  var form = document.getElementById('form-compra');
  if (form) {
    form.addEventListener('submit', function () {
      var texto = document.getElementById('boton-comprar-texto');
      if (texto) texto.textContent = 'Añadiendo...';
    });
  }
});
